import { useState } from "react";
import { Loader2, Delete, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, setToken, setActiveTokenKey, errMsg, storeLogoUrl } from "@/api";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "C", "0", "back"];

export function PinLogin({ slug, store, onSuccess }) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const press = (k) => {
    setErr("");
    if (k === "C") return setPin("");
    if (k === "back") return setPin((p) => p.slice(0, -1));
    if (pin.length < 6) setPin((p) => p + k);
  };

  const submit = async (e) => {
    e?.preventDefault();
    if (busy || pin.length < 4) return;
    setBusy(true); setErr("");
    try {
      const key = `reseller:${slug}`;
      const { data } = await api.post(`/public/stores/${slug}/reseller-login`, { pin });
      setToken(key, data.access_token);
      setActiveTokenKey(key);
      toast.success(`Selamat datang, ${data.reseller.name}`);
      onSuccess?.();
    } catch (ex) {
      setErr(errMsg(ex, "PIN salah"));
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="app-shell center-note" data-testid="pin-login">
      <form className="login-card pin-card" onSubmit={submit}>
        {store?.logo_path
          ? <img src={storeLogoUrl(store)} alt={`Logo ${store.store_name}`} className="store-logo" style={{ margin: "0 auto 8px", width: 64, height: 64 }} data-testid="pin-store-logo" />
          : <div className="login-icon" data-testid="pin-store-logo-default"><KeyRound size={26} /></div>}
        <h1 className="app-title">{store?.store_name || "Hotspot Order"}</h1>
        <p className="app-subtitle">{store?.subtitle || "Form Pesanan Voucher"}</p>
        <p className="pin-hint">Masukkan PIN reseller Anda untuk melihat harga dan memesan.</p>
        <input
          className="pin-input"
          type="password"
          inputMode="numeric"
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="••••"
          data-testid="pin-input"
          autoFocus
        />
        {err && <p className="error-text" data-testid="pin-error">{err}</p>}
        <div className="keypad">
          {KEYS.map((k) => (
            <button
              key={k}
              type="button"
              className={`key ${k === "C" || k === "back" ? "ghost" : ""}`}
              onClick={() => press(k)}
              data-testid={`pin-key-${k}`}
            >
              {k === "back" ? <Delete size={20} /> : k}
            </button>
          ))}
        </div>
        <button className="btn-primary full" type="submit" disabled={busy || pin.length < 4} data-testid="pin-submit">
          {busy ? <Loader2 className="spin" size={16} /> : <KeyRound size={16} />} Masuk
        </button>
        <p className="muted-sm center">Belum punya PIN? Hubungi admin toko untuk mendapatkan PIN lewat WhatsApp.</p>
        <p className="muted-sm center">Halaman ini khusus reseller toko ini. Admin toko masuk di <code>/toko/{slug}/admin</code>.</p>
      </form>
    </div>
  );
}
